/**
 * Created by Carsten Bühler
 * User: c.buehler on 04.10.2016
 * Copyright: xdot GmbH 2015
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { amdRequire } from 'plugin/liferay-widgets-react-web';
import Icon from './Icon';
import { Button } from 'external/react-bootstrap';

class MapConfigPluginDragItem extends React.Component {

  componentDidMount() {
    const curPath = this.props && this.props.item && this.props.item.path;

    if (curPath) {
      amdRequire([ curPath ], p => this.setState({ plugin: p }));
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const curPath = this.props && this.props.item && this.props.item.path,
      nextPath = nextProps && nextProps.item && nextProps.item.path;

    if (curPath !== nextPath) {
      amdRequire([ curPath ], p => this.setState({ plugin: p }));
    }
  }

  render() {
    const plugin = this.state && this.state.plugin;
    const { item, onDelete } = this.props;
    const exists = !!plugin;

    return (
      <div className="d-flex align-items-center justify-content-between w-100">
        <a onClick={this.props.onEdit && this.props.onEdit.bind(null, item)}>
          <span className={exists ? 'status status-green' : 'status status-red'}/>
          <h4>{item && item.path}</h4>
        </a>
        <Button
          variant="link"
          onClick={(e) => onDelete && onDelete(e, item)}
        >
          <Icon name="x red"/>
        </Button>
      </div>
    );

  }
}

MapConfigPluginDragItem.propTypes = {
  item: PropTypes.object,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func
};

export default MapConfigPluginDragItem;




// WEBPACK FOOTER //
// ./js/components/MapConfigPluginDragItem.jsx